export default __webpack_public_path__ + "static/media/dry-matter-icon.8c2bf2da.svg";